import { useLazyQuery } from '@apollo/client';
import { IQueryResult, IVariables } from './interfaces';
import { suppliersQuery } from './gql';

export const useSuppliersGql = () => {
  const [runSuppliersGql, { loading, data, error }] = useLazyQuery<IQueryResult, IVariables>(suppliersQuery, {
    context: {
      headers: {
        userFunctionKey: '1ff1de774005f8da13f42943881c655f'
      }
    }
  });

  return {
    runSuppliersGql,
    loadingSuppliers: loading,
    dataSuppliers: data?.suppliers || [],
    errorSuppliers: error
  };
};
